<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-sm-10">
      <h2 v-if="crumbs.length>0">{{$t("message."+crumbs[crumbs.length-1].text) }}</h2>
      <ol class="breadcrumb">
        <li class="breadcrumbs-item Medium" v-for="(crumb,index) in crumbs" :key="index">
            <router-link :to="{ path: crumb.to, query: { ...$route.query } }" >{{crumb.isData?crumb.text: $t(("message."+crumb.text)) }}</router-link>
        </li>
      </ol>
    </div>
  </div>
</template>
<script>
import broadcast from "../../lib/broadcast";
export default {
  name: "breadcrumbController",
  data() {
    return {
      crumbs: []
    };
  },
  computed: {
  },
  watch:{
    $route (to, from){
        this.crumbs = this.$route.meta.breadcrumbs
    }
  }, 
  methods: {
    setBreadcrumb: function(data) {
        this.crumbs = this.$route.meta.breadcrumbs
    }
  },
  created: function() {
  },
  mounted() {
    let that = this;
    this.setBreadcrumb();
  }
};
</script>
